import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('items'),
    itemColumnName: defineMessage('item'),
    quantityCommitted: defineMessage('committed'),
    quantityFulfilled: defineMessage('fulfilled'),
    quantityBilled: defineMessage('invoiced'),
    quantityBackOrdered: defineMessage('back_ordered'),
    quantity: defineMessage('quantity'),
    units: defineMessage('units'),
    description: defineMessage('description'),
    serialNumbers: defineMessage('seriallot_numbers'),
    priceLevel: defineMessage('price_level_1'),
    unitPrice: defineMessage('rate'),
    amount: defineMessage('amount'),
    taxCode: defineMessage('tax_code_1'),
    taxRate: defineMessage('tax_rate_1'),
    taxAmount: defineMessage('tax_amount_1'),
    grossAmount: defineMessage('gross_amount'),
    department: defineMessage('department'),
    class: defineMessage('class'),
    location: defineMessage('location'),
    orderPriority: defineMessage('order_priority'),
    revenueRecognitionSchedule: defineMessage('revenue_recognition_schedule'),
    revenueRecognitionStartDate: defineMessage('revenue_recognition_start_date'),
    revenueRecognitionEndDate: defineMessage('revenue_recognition_end_date'),
    excludeFromRateRequest: defineMessage('exclude_from_rate_request'),
    excludeFromRateRequestTooltip: defineMessage('exclude_from_rate_request'),
    closedColumnName: defineMessage('closed'),
    closedColumnTooltip: defineMessage('this_line_is_closed'),
};
